import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { BookEvent } from '../../types/Types';


export const useBookEvent = (
  options?: UseMutationOptions<BookEvent, unknown, BookEvent, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: BookEvent) =>
      axiosInstance
        .post(getAPIURL('/Event/AddEventAttendee'), data)
        .then((res) => res.data),
  });
};